import { render, staticRenderFns } from "./UserSession.vue?vue&type=template&id=10c2b9f2&scoped=true&"
import script from "./UserSession.vue?vue&type=script&lang=js&"
export * from "./UserSession.vue?vue&type=script&lang=js&"
import style0 from "./UserSession.vue?vue&type=style&index=0&id=10c2b9f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2b9f2",
  null
  
)

export default component.exports